import { Tag } from "pepsico-ds";
import PropTypes from "prop-types";
import "./surveyManagement.scss";

const sourceColors = {
  marigold: "Yellow-400",
  wsp: "Green-600",
};

const SurveySourceBadge = ({ source }) => {
  if (!source) return null;

  const color = sourceColors[source.toLowerCase().trim()] || "Auxiliary-600";

  return (
    <Tag
      className="survey-source-badge"
      color={color}
      size="small"
      text={source}
      isCopyable={false}
    />
  );
};

SurveySourceBadge.propTypes = {
  source: PropTypes.string,
};

export default SurveySourceBadge;
